/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CMSSandwichIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CMSSandwichIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.5752 2.79515C7.47691 2.2942 8.68875 2 10 2C11.3113 2 12.5231 2.2942 13.4248 2.79515C14.3096 3.2867 15 4.04561 15 5V11C15 11.9544 14.3096 12.7133 13.4248 13.2048C12.5231 13.7058 11.3113 14 10 14C8.68875 14 7.47691 13.7058 6.5752 13.2048C5.69042 12.7133 5 11.9544 5 11V5C5 4.04561 5.69042 3.2867 6.5752 2.79515ZM6 9.82287V11C6 11.4263 6.31694 11.9174 7.06084 12.3307C7.7878 12.7346 8.82597 13 10 13C11.174 13 12.2122 12.7346 12.9392 12.3307C13.6831 11.9174 14 11.4263 14 11V9.82287C13.8227 9.96383 13.6289 10.0915 13.4248 10.2048C12.5231 10.7058 11.3113 11 10 11C8.68875 11 7.47691 10.7058 6.5752 10.2048C6.37109 10.0915 6.17733 9.96383 6 9.82287ZM14 8C14 8.42632 13.6831 8.91741 12.9392 9.33069C12.2122 9.73456 11.174 10 10 10C8.82597 10 7.7878 9.73456 7.06084 9.33069C6.31694 8.91741 6 8.42632 6 8V6.82287C6.17733 6.96383 6.37109 7.09145 6.5752 7.20485C7.47691 7.7058 8.68875 8 10 8C11.3113 8 12.5231 7.7058 13.4248 7.20485C13.6289 7.09145 13.8227 6.96383 14 6.82287V8ZM12.9392 3.66931C13.6831 4.08259 14 4.57368 14 5C14 5.42632 13.6831 5.91741 12.9392 6.33069C12.2122 6.73456 11.174 7 10 7C8.82597 7 7.7878 6.73456 7.06084 6.33069C6.31694 5.91741 6 5.42632 6 5C6 4.57368 6.31694 4.08259 7.06084 3.66931C7.7878 3.26544 8.82597 3 10 3C11.174 3 12.2122 3.26544 12.9392 3.66931Z"
              fill="currentColor"
            />
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 2C8.68875 2 7.47691 2.2942 6.5752 2.79515C5.69042 3.2867 5 4.04561 5 5C5 5.95439 5.69042 6.7133 6.5752 7.20485C7.47691 7.7058 8.68875 8 10 8C11.3113 8 12.5231 7.7058 13.4248 7.20485C14.3096 6.7133 15 5.95439 15 5C15 4.04561 14.3096 3.2867 13.4248 2.79515C12.5231 2.2942 11.3113 2 10 2ZM6 5C6 4.57368 6.31694 4.08259 7.06084 3.66931C7.7878 3.26544 8.82597 3 10 3C11.174 3 12.2122 3.26544 12.9392 3.66931C13.6831 4.08259 14 4.57368 14 5C14 5.42632 13.6831 5.91741 12.9392 6.33069C12.2122 6.73456 11.174 7 10 7C8.82597 7 7.7878 6.73456 7.06084 6.33069C6.31694 5.91741 6 5.42632 6 5Z"
                fill="currentColor"
              />
              <path
                d="M10 13C8.82597 13 7.7878 12.7346 7.06084 12.3307C6.31694 11.9174 6 11.4263 6 11H5C5 11.9544 5.69042 12.7133 6.5752 13.2048C7.47691 13.7058 8.68875 14 10 14C11.3113 14 12.5231 13.7058 13.4248 13.2048C14.3096 12.7133 15 11.9544 15 11H14C14 11.4263 13.6831 11.9174 12.9392 12.3307C12.2122 12.7346 11.174 13 10 13Z"
                fill="currentColor"
              />
              <path d="M0 4H3V5H0V4Z" fill="currentColor" />
              <path d="M3 11H0V12H3V11Z" fill="currentColor" />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CMSSandwichIcon.tags = ['collection', 'coins', 'stack', 'caret', 'data'];

CMSSandwichIcon.category = 'General Icons';

CMSSandwichIcon.iconSize = 16;
